export const MSK_DELIVERY_MODE_BY_POINTS = "by_points";

export const MSK_DELIVERY_MODE_BY_POINTS_OPTION = {
  value: MSK_DELIVERY_MODE_BY_POINTS,
  label: "по точкам",
};
